// App.js
import React, { useEffect, useState } from "react";
import "./App.css";
import GlobalStyles from "./assets/GlobalStyle";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  USER_NAME,
  USER_EMAIL,
  IS_SOCIAL_LOGGED_IN,
  EXPERT_DETAIL_DATA,
  IS_MOBILE,
  IS_DESKTOP_SCALE,
  IS_MARKETING,
  APPROACH_PATH,
} from "./pages/AtomStates"; // 로그인 상태 아톰 임포트

import styled, { css } from "styled-components";
import images from "./assets/styles/Images";
import { palette } from "./assets/styles/Palette";
import {
  checkTokenValidity,
  checkBackendServerStatus,
} from "./utils/indexedDB";

import PageTerms from "./pages/PageTerms";
import PagePolicy from "./pages/PagePolicy";
import PageDashBoard from "./pages/DashBoard/pages/PageDashBoard";
import PageApiDashBoard from "./pages/DashBoard/pages/PageApiDashBoard";
import PageEducationDashBoard from "./pages/DashBoard/pages/PageEducationDashBoard";
import PageCustomerManage from "./pages/DashBoard/pages/PageCustomerManage";
import PageStyleGuide from "./pages/DesignPage/PageStyleGuide";

//! 로그인, 회원가입
import OrganismLogin from "./pages/Global/components/organisms/OrganismLogin";
import OrganismSignupAutodisplay from "./pages/Global/components/organisms/OrganismSignupAutodisplay";

import PageCreateConent from "./pages/CreateContentPage/pages/PageCreateContent";
import PageCreateApiContent from "./pages/CreatApiContentPage/pages/PageCreateApiContent";
import PageCreateEducationContent from "./pages/CreateEducationContentPage/pages/PageCreateEducationContent";
import PageCreateEducationMeal from "./pages/CreateEducationContentPage/pages/PageCreateEducationMeal";
import PageMoleculeMenuBoardKiosk from "./pages/MoleculeMenuBoardKiosk";
import PageMoleculeSizeModeArea from "./pages/Global/components/molecules/MoleculeSizeModeArea";
import PageMoleculeMenuBoardKioskWidth from "./pages/MoleculeMenuBoardKioskWidth";
//! 테스트

import MoleculeContentTimeline from "./pages/CreateEducationContentPage/components/molecules/MoleculeContentTimeline";
import MoleculeContentTimeMonth from "./pages/CreateEducationContentPage/components/molecules/MoleculeContentTimeMonth";
import OrganismsContentPopup from "./pages/CreateEducationContentPage/components/organisms/OrganismsContentPopup";
import MoleculePopupBoard from "./pages/CreateEducationContentPage/components/molecules/MoleculePopupBoard";

import PageAutodisplayView from "./pages/AutodisplayView/pages/PageAutodisplayView";
import PageAutodisplayViewApi from "./pages/AutodisplayView/pages/PageAutodisplayViewApi";
import ComponentTest from "./pages/ComponentTest";
import AtomsGaugeTest from "./pages/AtomsGaugeTest";
import PageAdmin from "./pages/PageAdmin";
import PageDeviceSelection from "./pages/PageDeviceSelection";
import PageAutodisplayLanding from "./pages/Landing/pages/PageAutodisplayLanding";
import PageAutodisplayMobileLanding from "./pages/Landing/pages/PageAutodisplayMobileLanding";
import TestMoleculeBackgroundSimpleWide from "./pages/TestMoleculeBackgroundSimpleWide";
import PageAutodisplayViewLink from "./pages/AutodisplayView/pages/PageAutodisplayViewLink";
import PageAutodisplayViewLinkEdu from "./pages/AutodisplayView/pages/PageAutodisplayViewLinkEdu";
import PageAutodisplayViewLinkEduLotation from "./pages/AutodisplayView/pages/PageAutodisplayViewLinkEduLotation";
import PageAutodisplayViewEdu from "./pages/AutodisplayView/pages/PageAutodisplayViewEdu";
import PageAutodisplayViewLinkEduMobileLotation from "./pages/AutodisplayView/pages/PageAutodisplayViewLinkEduMobileLotation";

import OrganismDisplayViewApi from "./pages/AutodisplayView/components/organisms/OrganismDisplayViewApi";
import OrganismDisplayViewApiFixed from "./pages/AutodisplayView/components/organisms/OrganismDisplayViewApiFixed";
import OrganismDisplayViewCustom from "./pages/AutodisplayView/components/organisms/OrganismDisplayViewCustom";

import OrganismTemplatePreview from "./pages/Global/components/organisms/OrganismTemplatePreview";
import PageAutodisplayViewLinkApiLotation from "./pages/AutodisplayView/pages/PageAutodisplayViewLinkApiLotation";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN); // 로그인 상태를 위한 아톰
  const [, setUserName] = useAtom(USER_NAME); // 유저 이름 아톰
  const [, setUserEmail] = useAtom(USER_EMAIL); // 유저 이메일 아톰
  const [, setIsSocialLoggedIn] = useAtom(IS_SOCIAL_LOGGED_IN); // 소셜 로그인 상태 아톰
  const [isServerDown, setIsServerDown] = useState(false); // 서버 상태 관리s
  const [, setExpertDetail] = useAtom(EXPERT_DETAIL_DATA); // 화면 크기를 체크하는 useEffect
  const [isMobile, setIsMobile] = useAtom(IS_MOBILE);
  const [isDesktopScale, setIsDesktopScale] = useAtom(IS_DESKTOP_SCALE);

  // 토큰 존재 여부 확인 컴포넌트
  function RequireToken({ children }) {
    const token = sessionStorage.getItem("accessToken");
    if (!token) {
      return <Navigate to="/Login" replace />;
    }
    return children;
  }

  // 로그인 상태에서 로그인/회원가입 페이지 접근 제한 컴포넌트
  function RedirectIfLoggedIn({ children }) {
    const [redirect, setRedirect] = useState(null);
    const [isChecking, setIsChecking] = useState(true);
    const token = sessionStorage.getItem("accessToken");

    useEffect(() => {
      const checkUserAndRedirect = async () => {
        if (!token) {
          setIsChecking(false);
          return;
        }

        try {
          const { getUserInfo, getUserMemberType, getEduBoardListOnServer } =
            await import("./utils/indexedDB");
          const userInfo = await getUserInfo(token);

          const memberTypeStr = String(userInfo.member_type);

          if (memberTypeStr.startsWith("3")) {
            const eduBoardList = await getEduBoardListOnServer(999, 1, true);

            let destination;
            if (userInfo.member_type === 31) {
              // 현재 사용자의 이메일과 일치하는 manager 개수 확인
              const userEmail = userInfo.email;
              const managedBoards = eduBoardList.data.filter(
                (board) => board.manager === userEmail
              );
              const managedBoardsCount = managedBoards.length;

              if (managedBoardsCount === 1) {
                sessionStorage.setItem("customerId", managedBoards[0]._id);
                destination = "/EducationDashBoard";
              } else if (managedBoardsCount >= 2) {
                destination = "/CustomerManage";
              } else {
                destination = "/CustomerManage";
              }
            } else if (userInfo.member_type === 32) {
              destination = "/EducationDashBoard";
            }

            setRedirect(destination);
          } else if (userInfo.member_type === 99) {
            setRedirect("/Admin");
          } else if (
            userInfo.member_type === 12 ||
            userInfo.member_type === 22
          ) {
            setRedirect("/CustomerManage");
          } else if (userInfo.member_type === 11) {
            setRedirect("/DashBoard");
          } else if (userInfo.member_type === 21) {
            setRedirect("/ApiDashBoard");
          } else {
            setRedirect("/CustomerManage");
          }
        } catch (error) {
          console.error("Error checking user info:", error);
          setRedirect("/CustomerManage");
        } finally {
          setIsChecking(false);
        }
      };

      checkUserAndRedirect();
    }, [token]);

    if (isChecking) {
      return <div>Loading...</div>; // 또는 로딩 스피너
    }

    if (redirect) {
      return <Navigate to={redirect} replace />;
    }

    return children;
  }

  useEffect(() => {
    const detectMobileDevice = () => {
      // 1. 화면 크기를 통한 모바일 감지 (가장 정확한 방법)
      const screenWidth = window.innerWidth;
      const isMobileScreen = screenWidth <= 768;

      // 2. User-Agent를 통한 모바일 디바이스 감지
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = [
        "android",
        "webos",
        "iphone",
        "ipad",
        "ipod",
        "blackberry",
        "windows phone",
        "mobile",
        "tablet",
        "kindle",
        "silk",
        "opera mini",
        "opera mobi",
      ];

      const isMobileDevice = mobileKeywords.some((keyword) =>
        userAgent.includes(keyword)
      );

      // 3. 최종 모바일 판단 (화면 크기와 User-Agent만 사용)
      const isMobile = isMobileScreen || isMobileDevice;

      setIsMobile(isMobile);

      // 4. 데스크탑 환경에서 스케일 적용 여부 결정
      // 화면 너비가 1200px 이상이고 모바일이 아닌 경우 스케일 적용
      const shouldApplyDesktopScale = !isMobile && screenWidth >= 1200;

      setIsDesktopScale(shouldApplyDesktopScale);
    };

    // 페이지 로드 시 디바이스 체크
    detectMobileDevice();

    // 윈도우 리사이즈 이벤트 리스너 추가
    const handleResize = () => {
      detectMobileDevice();
    };

    window.addEventListener("resize", handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setIsMobile, setIsDesktopScale]);

  // 애플리케이션이 로드될 때 로그인 상태 확인
  useEffect(() => {
    const token = sessionStorage.getItem("accessToken"); // sessionStorage에서 토큰 확인
    const storedUserName = sessionStorage.getItem("userName");
    const storedUserEmail = sessionStorage.getItem("userEmail");
    const isSocialLogin = sessionStorage.getItem("isSocialLogin"); // 소셜 로그인 여부 확인

    if (token && storedUserName) {
      setIsLoggedIn(true); // 토큰이 있으면 로그인 상태로 설정
    } else {
      setIsLoggedIn(false); // 토큰이 없으면 로그아웃 상태로 설정
    }

    if (storedUserName) {
      setUserName(storedUserName); // 이름 아톰 업데이트
    }

    if (storedUserEmail) {
      setUserEmail(storedUserEmail); // 이메일 아톰 업데이트
    }
    if (isSocialLogin === "true") {
      setIsSocialLoggedIn(true); // 소셜 로그인 상태 업데이트
    } else {
      setIsSocialLoggedIn(false); // 일반 로그인 상태로 설정
    }
  }, [setIsLoggedIn, setUserName, setUserEmail]);

  // 10분마다 서버 상태 체크
  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");

    const checkServerStatus = async () => {
      if (token) {
        try {
          await checkTokenValidity();
        } catch (error) {
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("lastUrl");
          sessionStorage.removeItem("userCreatedAt");
          sessionStorage.removeItem("userName");
          sessionStorage.removeItem("userEmail");
          sessionStorage.removeItem("isSocialLogin");
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          setIsLoggedIn(false);
          setUserName("");
          setUserEmail("");
          window.location.reload();
        }
      } else {
        try {
          const response = await checkBackendServerStatus();
          // 서버가 정상일 경우
          setIsServerDown(false);
        } catch (error) {
          if (
            window.location.pathname !== "/Login" &&
            !window.location.pathname.includes("View")
          ) {
            // 서버가 응답하지 않거나 에러 발생 시 서버 다운 처리
            setIsServerDown(true);

            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("lastUrl");
            sessionStorage.removeItem("userCreatedAt");
            sessionStorage.removeItem("userName");
            sessionStorage.removeItem("userEmail");
            sessionStorage.removeItem("isSocialLogin");
            localStorage.removeItem("userName");
            localStorage.removeItem("userEmail");
            setIsLoggedIn(false);
            setUserName("");
            setUserEmail("");
          }
        }
      }
    };

    // 처음 실행
    checkServerStatus();

    // 10분마다 실행
    const intervalId = setInterval(() => {
      checkServerStatus();
    }, 600000); // 600초마다 서버 상태 확인

    return () => clearInterval(intervalId); // 컴포넌트 언마운트 시 정리
  }, []);

  return (
    <div className="App">
      {/* 스타일 컴퍼넌트 적용 */}
      <GlobalStyles />

      {/* 서버 점검 중 경고창 */}
      {isServerDown && (
        <Popup
          Cancel
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              window.location.href = "/";
            }
          }}
        >
          <div>
            <button
              type="button"
              className="closePopup"
              onClick={() => (window.location.href = "/")}
            >
              닫기
            </button>
            <span>
              <img src={images.ExclamationMark2} alt="" />
            </span>
            <p>
              서버가 점검 중입니다
              <br />
              잠시 후 다시 시도해 주세요
            </p>
            <div className="btnWrap">
              <button
                type="button"
                onClick={() => (window.location.href = "/")}
              >
                확인
              </button>
            </div>
          </div>
        </Popup>
      )}

      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              isMobile ? (
                <PageAutodisplayMobileLanding />
              ) : (
                <PageAutodisplayLanding />
              )
            } // 디바이스에 따라 다른 랜딩 페이지 설정
          />
          <Route
            path="/mobile"
            element={<PageAutodisplayMobileLanding />} // 모바일 랜딩 페이지 (호환성을 위해 유지)
          />
          {/* <Route
            path="*"
            element={
                <PageLogin />
            }
          /> */}

          <Route
            path="/Login"
            element={
              <RedirectIfLoggedIn>
                <OrganismLogin />
              </RedirectIfLoggedIn>
            }
          />

          <Route
            path="/SignupAutodisplay"
            element={
              // <RedirectIfLoggedIn>
              <OrganismSignupAutodisplay />
              // </RedirectIfLoggedIn>
            }
          />

          <Route
            path="/Admin"
            element={
              <RequireToken>
                <PageAdmin />
              </RequireToken>
            }
          />

          <Route
            path="/DeviceSelection"
            element={
              <RequireToken>
                <PageDeviceSelection />
              </RequireToken>
            }
          />

          <Route
            path="/CustomerManage"
            element={
              <RequireToken>
                <PageCustomerManage />
              </RequireToken>
            }
          />

          <Route
            path="/EduboardManage"
            element={
              <RequireToken>
                <PageCustomerManage />
              </RequireToken>
            }
          />

          <Route
            path="/DashBoard"
            element={
              <RequireToken>
                <PageDashBoard />
              </RequireToken>
            }
          />

          <Route
            path="/ApiDashBoard"
            element={
              <RequireToken>
                <PageApiDashBoard />
              </RequireToken>
            }
          />
          <Route
            path="/EducationDashBoard"
            element={
              <RequireToken>
                <PageEducationDashBoard />
              </RequireToken>
            }
          />

          <Route
            path="/CreateContent"
            element={
              <RequireToken>
                <PageCreateConent />
              </RequireToken>
            }
          />

          <Route
            path="/CreateApiContent"
            element={
              <RequireToken>
                <PageCreateApiContent />
              </RequireToken>
            }
          />
          <Route
            path="/CreateEducationContent"
            element={
              <RequireToken>
                <PageCreateEducationContent />
              </RequireToken>
            }
          />
          <Route
            path="/CreateEducationMeal"
            element={
              <RequireToken>
                <PageCreateEducationMeal />
              </RequireToken>
            }
          />

          <Route
            path="/TemplatePreview"
            element={
              <RequireToken>
                <OrganismTemplatePreview />
              </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewApi"
            element={
              // <RequireToken>
              <PageAutodisplayViewApi />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewApi/:path"
            element={
              // <RequireToken>
              <PageAutodisplayViewApi />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewLink/:path"
            element={
              // <RequireToken>
              <PageAutodisplayViewLink />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewLinkEdu/:path"
            element={
              // <RequireToken>
              <PageAutodisplayViewLinkEdu />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewEdu"
            element={<PageAutodisplayViewEdu />}
          />

          <Route
            path="/AutodisplayViewEdu/:path"
            element={<PageAutodisplayViewEdu />}
          />

          <Route
            path="/AutodisplayViewLinkEduLotation/:path"
            element={<PageAutodisplayViewLinkEduLotation />}
          />

          <Route
            path="/AutodisplayViewLinkApiLotation/:path"
            element={<PageAutodisplayViewLinkApiLotation />}
          />

          <Route
            path="/AutodisplayViewLinkEduMobileLotation/:path"
            element={<PageAutodisplayViewLinkEduMobileLotation />}
          />  

          {/* <Route
            path="/AutodisplayViewCustom"
            element={
              // <RequireToken>
              <PageAutodisplayViewCustom />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewCustom/:path"
            element={
              // <RequireToken>
              <PageAutodisplayViewCustom />
              // </RequireToken>
            }
          /> */}

          {/* <Route
            path="/AutodisplayViewCustomBlack"
            element={
              // <RequireToken>
              <PageAutodisplayViewCustomBlack />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayViewCustomWhite"
            element={
              // <RequireToken>
              <PageAutodisplayViewCustomWhite />
              // </RequireToken>
            }
          /> */}

          <Route
            path="/AutodisplayView"
            element={
              // <RequireToken>
              <PageAutodisplayView />
              // </RequireToken>
            }
          />

          <Route
            path="/AutodisplayView/:path"
            element={
              // <RequireToken>
              <PageAutodisplayView />
              // </RequireToken>
            }
          />

          <Route
            path="/MoleculeKiosk"
            element={
              // <RequireToken>
              <PageMoleculeMenuBoardKiosk />
              // </RequireToken>
            }
          />

          <Route
            path="/MoleculeKiosWidth"
            element={
              // <RequireToken>
              <PageMoleculeMenuBoardKioskWidth />
              // </RequireToken>
            }
          />

           <Route
            path="/MoleculeModeArea"
            element={
              // <RequireToken>
              <PageMoleculeSizeModeArea />
              // </RequireToken>
            }
          />

          <Route path="/test-timeline" element={<MoleculeContentTimeline />} />

          <Route path="/Terms" element={<PageTerms />} />
          <Route path="/Policy" element={<PagePolicy />} />

          <Route path="/test-popup" element={<OrganismsContentPopup />} />

          <Route path="/test-month" element={<MoleculeContentTimeMonth />} />

          <Route path="/test-popup-board" element={<MoleculePopupBoard />} />

          {/* <Route
            path="/blog"
            element={
              // <RequireToken>
              <PageBlog />
              // </RequireToken>
            }
          /> */}

          <Route path="/style_guide" element={<PageStyleGuide />} />

          {/* 컴포넌트 테스트 페이지 */}
          <Route path="/component-test" element={<ComponentTest />} />
          <Route path="/atoms-gauge-test" element={<AtomsGaugeTest />} />
          <Route
            path="/test-molecule-background-simple-wide"
            element={<TestMoleculeBackgroundSimpleWide />}
          />

          {/* <Route
            path="/organism-display-view-api-test"
            element={<OrganismDisplayViewApi />}
          /> */}
          <Route
            path="/gA4d9m"
            // element={
            //   <OrganismDisplayViewApiFixed
            //     path="test-path"
            //     activateCode="test-code"
            //     activateTimestamp={Date.now()}
            //     textData="강원도 고성 오늘의 날씨. 실시간 날씨 정보를 확인해보세요!"
            //     locationData={{
            //       selectedRegion: "강원도 고성군",
            //       selectedDistricts: {
            //         district: "고성군",
            //         x: 85,
            //         y: 145,
            //       },
            //     }}
            //     themeMode="dark"
            //   />
            // }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  z-index: 9999;

  .closePopup {
    position: absolute;
    right: 24px;
    top: 24px;
    width: 16px;
    height: 16px;
    font-size: 0;
    padding: 11px;
    border: 0;
    background: none;

    &:before,
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 100%;
      border-radius: 10px;
      background: ${palette.black};
      content: "";
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  > div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    text-align: center;
    // overflow:hidden;
    padding: 45px 24px 24px;
    border-radius: 10px;
    background: ${palette.white};

    p {
      font-family: "Pretendard", "Poppins";
      font-size: 0.875rem;
      font-weight: 500;
      margin: 20px auto 24px;
      line-height: 1.5;
    }

    .btnWrap {
      display: flex;
      align-items: center;
      gap: 16px;

      button {
        flex: 1;
        font-family: "Pretendard", "Poppins";
        font-size: 0.875rem;
        font-weight: 600;
        color: ${palette.blue};
        padding: 12px 20px;
        border-radius: 8px;
        border: 1px solid ${palette.blue};
        background: ${palette.white};

        &:last-child {
          color: ${palette.white};
          background: ${palette.blue};
        }
      }
    }

    ${(props) =>
      props.Cancel &&
      css`
        p {
          strong {
            font-weight: 500;
            display: block;
          }
          span {
            font-size: 0.75rem;
            font-weight: 400;
            color: ${palette.gray500};
            display: block;
            margin-top: 8px;
          }
        }

        .btnWrap {
          padding-top: 16px;
          border-top: 1px solid ${palette.lineGray};

          button {
            font-family: "Pretendard", "Poppins";
            color: ${palette.gray};
            font-weight: 600;
            padding: 0;
            border: 0;
            background: none;

            &:last-child {
              color: ${palette.blue};
              background: none;
            }
          }
        }
      `}
  }
`;
